module.exports = __webpack_public_path__ + "img/imagem_conecta_track.0ca3110a.jpg";